import type { RootState } from 'src/store';
import { connect } from 'react-redux';

import {
    getActiveSurfaceName,
    getDecorationSpecs,
    getSurfaceProperties,
    getBodyMeasurementOverrideForCurrentSize,
} from 'src/selectors/pages/editor';
import {
    setBodyMeasurementOverride,
    clearBodyMeasurementOverride,
} from 'src/pages/editor/components/decorationSpecs/slice';

import decorationSpecs from './decorationSpecs';

const mapStateToProps = (state: RootState) => {
    const {
        isLoading,
        decorationPlacement,
        printWhite,
        sizeChart,
        decorationMissingSelections,
        bodyWidthMm,
        bodyLengthMm,
    } = getDecorationSpecs(state);
    const { merchantVariables } = getSurfaceProperties(state);

    return {
        isLoading,
        decorationPlacement,
        printWhite,
        sizeChart,
        decorationMissingSelections,
        currentSize: merchantVariables?.Size,
        activeSurfaceName: getActiveSurfaceName(state),
        bodyWidthMm,
        bodyLengthMm,
        bodyMeasurementOverride: getBodyMeasurementOverrideForCurrentSize(state),
    };
};

const mapDispatchToProps = {
    onSetBodyMeasurementOverride: setBodyMeasurementOverride,
    onClearBodyMeasurementOverride: clearBodyMeasurementOverride,
};

const decorationSpecsContainer = connect(mapStateToProps, mapDispatchToProps)(decorationSpecs);

export default decorationSpecsContainer;
